module.exports = __webpack_public_path__ + "static/media/river3.496c9b4f.png";